import { render, staticRenderFns } from "./PartnerTabs.vue?vue&type=template&id=9884ddfc&scoped=true&"
import script from "./PartnerTabs.vue?vue&type=script&lang=js&"
export * from "./PartnerTabs.vue?vue&type=script&lang=js&"
import style1 from "./PartnerTabs.vue?vue&type=style&index=1&id=9884ddfc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9884ddfc",
  null
  
)

export default component.exports